import {
  Address,
  TermsConditions,
  TravelDetails,
  NewTravelPolicyState,
  TravelPlan,
  PersonalDetails,
  Requester,
  Traveller,
  Identity,
} from "../../types/travel/Policy";

const defaultTravelDetails: TravelDetails = {
  policyType: null,
  location: null,
  adultCount: 1,
  childrenCount: 0,
  travellerType: null,
  groupType: null,
  startDate: null,
  endDate: null,
};

export const defaultTravelPlan: TravelPlan = {
  planName: null,
  planPrice: null,
  planCurrency: null,
};

export const defaultAddress: Address = {
  postalCode: "",
  number: "",
  streetName: "",
  floorNumber: "",
  unitNumber: "",
  buildingName: "",
};

export const defaultIdentity: Identity = {
  identificationNumber: "",
  identificationNumberStatus: "unknown",
  dateOfBirth: null,
};

export const defaultRequester: Requester = {
  fullName: "",
  phoneNumber: "",
  email: "",
  ...defaultIdentity,
};

export const defaultTraveller: Traveller = {
  fullName: "",
  isChild: false,
  ...defaultIdentity,
};

const defaultPersonalDetails: PersonalDetails = {
  requester: defaultRequester,
  requestingPersonIsTravelingPerson: true,
  isTravellerTypeGroup: false,
  travellers: [],
  childTravellers: [],
};

const defaultTermsConditions: TermsConditions = {
  accepted: false,
  marketingVoiceCall: false,
  marketingTextMessage: false,
};

export const createInitialNewTravelPolicyState = (): NewTravelPolicyState => {
  return {
    travelDetails: defaultTravelDetails,
    travelPlan: defaultTravelPlan,
    personalDetails: defaultPersonalDetails,
    termsConditions: defaultTermsConditions,
  };
};
